import React from 'react';
import { NumericFormat } from 'react-number-format';

export const Range = ({
  value,
  setValue,
  maxRange,
  step,
  minRange,
}: {
  value: number;
  setValue: (value: number) => void;
  maxRange: number;
  step: number;
  minRange?: number;
}) => {
  return (
    <div className="plerion-pricing">
      <div className="pricing-container">
        <div className="pricing-sub-container">
          <h4
            className={`-translate-x-1/2 font-semibold whitespace-nowrap`}
            style={{
              left: `${(Number(value) / maxRange) * 100}%`,
            }}
          >
            <NumericFormat
              displayType="text"
              thousandSeparator={true}
              value={value}
              renderText={(value) => value}
            />
            {value === maxRange && ' +'}
            <span className="border-br-primary absolute -bottom-[5px] h-0 w-0 rounded-md border-[10px] border-b-0 border-x-transparent"></span>
          </h4>
        </div>
      </div>
      <input
        type="range"
        value={value}
        max={maxRange}
        step={step}
        min={minRange}
        onChange={(event) => setValue(Number(event.currentTarget.value))}
      />
    </div>
  );
};
